module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/029-comoros-a34f1becea844b2ff3a0b2f204d2526c.svg";